enum NotificationIcon {
    Success = 'SUCCESS',
    Info = 'INFO',
    Warning = 'WARNING',
    Danger = 'DANGER',
    Logout = 'LOGOUT',
}

export default NotificationIcon;
